var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3048_28460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4596 0.424805C25.0939 0.424805 24.7969 0.723306 24.7969 1.09084V8.61461V10.1761C24.7969 10.5437 25.0939 10.8422 25.4596 10.8422H34.1407C34.5064 10.8422 34.8034 11.1407 34.8034 11.5082V20.2328C34.8034 20.6003 35.1004 20.8988 35.4661 20.8988H37.0199H44.5061C44.8718 20.8988 45.1689 20.6003 45.1689 20.2328V1.09181C45.1689 0.724277 44.8718 0.425778 44.5061 0.425778H25.4606L25.4596 0.424805Z",
    fill: "#B1C3E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.168 33.183V31.6215C45.168 31.254 44.871 30.9555 44.5053 30.9555H15.4523C15.0866 30.9555 14.7895 30.657 14.7895 30.2894V1.09182C14.7895 0.724281 14.4925 0.425781 14.1268 0.425781H5.08777C4.72206 0.425781 4.42505 0.724281 4.42505 1.09182V40.7068C4.42505 41.0743 4.72206 41.3728 5.08777 41.3728H44.5053C44.871 41.3728 45.168 41.0743 45.168 40.7068V33.183Z",
    fill: "#B1C3E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3561 2.64648C25.0475 2.64648 24.7969 2.9126 24.7969 3.24025V9.94766V11.3398C24.7969 11.6674 25.0475 11.9335 25.3561 11.9335H32.681C32.9896 11.9335 33.2402 12.1996 33.2402 12.5273V20.3052C33.2402 20.6329 33.4909 20.899 33.7994 20.899H35.1105H41.4273C41.7358 20.899 41.9865 20.6329 41.9865 20.3052V3.24112C41.9865 2.91346 41.7358 2.64735 41.4273 2.64735H25.3569L25.3561 2.64648Z",
    fill: "#7E9CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9858 31.8504V30.4583C41.9858 30.1306 41.7352 29.8645 41.4266 29.8645H16.912C16.6034 29.8645 16.3528 29.5984 16.3528 29.2708V3.24123C16.3528 2.91357 16.1022 2.64746 15.7936 2.64746H8.16661C7.85804 2.64746 7.60742 2.91357 7.60742 3.24123V38.5578C7.60742 38.8855 7.85804 39.1516 8.16661 39.1516H41.4266C41.7352 39.1516 41.9858 38.8855 41.9858 38.5578V31.8504Z",
    fill: "#7E9CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4756 5.62988C25.2212 5.62988 25.0146 5.84913 25.0146 6.11908V11.6452V12.7922C25.0146 13.0621 25.2212 13.2814 25.4756 13.2814H31.5141C31.7684 13.2814 31.975 13.5006 31.975 13.7706V20.1787C31.975 20.4487 32.1816 20.6679 32.436 20.6679H33.5168H38.7241C38.9785 20.6679 39.1851 20.4487 39.1851 20.1787V6.1198C39.1851 5.84984 38.9785 5.6306 38.7241 5.6306H25.4763L25.4756 5.62988Z",
    fill: "#164CAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1844 29.6908V28.5439C39.1844 28.2739 38.9778 28.0547 38.7235 28.0547H18.5146C18.2602 28.0547 18.0536 27.8355 18.0536 27.5655V6.12006C18.0536 5.85011 17.847 5.63086 17.5926 5.63086H11.3052C11.0508 5.63086 10.8442 5.85011 10.8442 6.12006V35.217C10.8442 35.4869 11.0508 35.7062 11.3052 35.7062H38.7235C38.9778 35.7062 39.1844 35.4869 39.1844 35.217V29.6908Z",
    fill: "#164CAE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3048_28460",
    x: 0.425049,
    y: 0.424805,
    width: 48.7439,
    height: 48.9482,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3048_28460"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3048_28460",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai_icon.09b4ba140891edbe41328727c6d9a529.svg";
export { ForwardRef as ReactComponent };